import React from 'react'
import Failure from "../../Assets/Images/failure.png"
import { useNavigate } from "react-router-dom";

const AppoinmentFailurePage = () => {
    const navigate = useNavigate();
  return (
   
          <div className="test-success-container">
          <img src={Failure} alt="Success Tick Icon" className="tick-icon" />
          <p className="tsuccess-messages">Booking Failed</p>
          <button className="thome-button" onClick={() => navigate('/home')}>Home</button>
        </div>
      )
    }
export default AppoinmentFailurePage